export default __webpack_public_path__ + "static/media/pinkSearch.3bc08eec.svg";